import { MAP_ID, ZOOM_LEVEL } from '../../maps/config';

/**
 * @function initYandexMap - инициализирует карту на странице городов
 * @param {YaMap} ymaps - глобальный объект предоставляющий доступ к карте
 * */

export default function initYandexMap(ymaps = {}) {
    if (!ymaps.hasOwnProperty('Map')) {
        setTimeout(initYandexMap, 100, window.ymaps);
        return;
    }

    const myMap = new ymaps.Map(MAP_ID, { center: [ 0, 0 ], zoom: ZOOM_LEVEL });

    ymaps.geocode(currentCity, { results: 1 }).then(function (res) {
        const firstGeoObject = res.geoObjects.get(0);
        const bounds = firstGeoObject.properties.get('boundedBy');

        firstGeoObject.options.set('preset', 'islands#darkBlueDotIconWithCaption');
        firstGeoObject.properties.set('iconCaption', firstGeoObject.getAddressLine());

        myMap.geoObjects.add(firstGeoObject);

        myMap.setBounds(bounds, {checkZoomRange: true});
    });
}
